import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #042E4B 0%, #0A4A6F 100%);
  padding: 2rem;
`;

const Title = styled(motion.h1)`
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 2rem;
  text-align: center;
`;

const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1400px;
  width: 100%;
  align-items: center;
`;

const FlowSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FlowCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  color: #042E4B;
  padding: 1.5rem 2rem;
  border-radius: 12px;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
`;

const Arrow = styled(motion.div)`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 20px solid #EF443C;
  margin: -3px 0;
  align-self: center;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3));
`;

const ScreenshotSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const ScreenshotFrame = styled(motion.div)`
  background: white;
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 30px;
    background: linear-gradient(90deg, #EF443C, #C43931);
    border-radius: 16px 16px 0 0;
  }
`;

const ScreenshotImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-top: 30px;
`;

const ScreenshotLabel = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  color: #042E4B;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1.2rem;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const Slide9MetodologiaWithScreenshot: React.FC = () => {
  const methodologySteps = [
    'Definição de Missão, Visão e Valores',
    'Análise Ambiente Interno e Externo',
    'Análise SWOT Completa',
    'Definição de Metas Globais',
    'Criação de Planos de Ação',
    'Monitoramento e Avaliação',
  ];

  return (
    <Container>
      <Title
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        Metodologia Completa na Prática
      </Title>

      <MainContent>
        <FlowSection>
          {methodologySteps.map((step, index) => (
            <React.Fragment key={step}>
              <FlowCard
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.3, delay: 0.1 + index * 0.08 }}
              >
                {step}
              </FlowCard>
              {index < methodologySteps.length - 1 && (
                <Arrow
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.15, delay: 0.2 + index * 0.08 }}
                />
              )}
            </React.Fragment>
          ))}
        </FlowSection>

        <ScreenshotSection>
          <ScreenshotFrame
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <ScreenshotImage
              src="/screenshots/screenshot1.png"
              alt="Dashboard da ThinkWay"
            />
          </ScreenshotFrame>
          <ScreenshotLabel
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.7 }}
          >
            📊 Dashboard Integrado
          </ScreenshotLabel>
        </ScreenshotSection>
      </MainContent>
    </Container>
  );
};

export default Slide9MetodologiaWithScreenshot;